import { MDBSelect } from "mdb-react-ui-kit";

const SelectField = ({ ...restProps }) => {
    return <MDBSelect search {...restProps} size='sm'/>;
};

export default SelectField;
